import gql from 'graphql-tag'

const listProductsByCode = gql`
query listProducts_byCode($filter: ProductFilterArgs $params: ListQueryArgs) {
	cashAssist {
		listProducts(filter: $filter, params: $params) {
			items {
				id
				name
				code
				isActive
			}
		}
	}
}`

export default listProductsByCode
